const trimPhoneNumber = (phoneNumber: string): string => {
  return phoneNumber.replace('(', '').replace(')', '').replace(/ /g, '').replace('-', '')
}

export {trimPhoneNumber}
